/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Button } from '@/primitives/Button';
import { tokens } from '@/theme';

export type BackButtonProps = {
  to: string;
  label?: string;
};

export function BackButton({ to, label }: BackButtonProps) {
  const navigate = useNavigate();
  const { t } = useMimicTranslation('global');

  const handleClick = () => {
    navigate(to);
  };

  return (
    <Button type="link" onClick={handleClick} style={{ padding: 0 }} dataTestId="back-button">
      <span style={{ fontWeight: 'bold', color: tokens.color.primary.primaryBlack }}>
        <ArrowLeftOutlined style={{ color: tokens.color.primary.primaryBlack }} /> {label || t('back')}
      </span>
    </Button>
  );
}
